<!--<div class="desktop-header" *ngIf="windowService.isDesktopRes">
<tidy-text
  [title]="'Schedule'">
</tidy-text>
<div class="vertical-align-center">
  <tidy-image
    (click)="goToPreviousPeriod()"
    [src]="'assets/icon/arrowhead.png'"
    class="body-size arrow-icon reverse-arrow">
  </tidy-image>
  <tidy-text
    [body]="getPeriodRangeText()">
  </tidy-text>
  <tidy-image
    (click)="goToNextPeriod()"
    [src]="'assets/icon/arrowhead.png'"
    class="body-size arrow-icon last-arrow">
  </tidy-image>
</div>
<div style="width: 80px">
  <form [formGroup]="form">
    <tidy-select
      [items]="scheduleViewModeList"
      [form]="form.get('scheduleViewMode')"
      formControlName="scheduleViewMode"
      (optionChange)="changeScheduleViewMode($event)"
      class="desktop-header-field">
    </tidy-select>
  </form>
</div>
<div style="width: 180px">
  <form [formGroup]="form">
    <tidy-input
      #searchInput
      class="desktop-header-field"
      [icon]="'assets/svg/search.svg'"
      [activeIcon]="'assets/svg/search-tidy-green.svg'"
      [noBorder]="true"
      type="search"
      formControlName="search"
      [label]="'Search'"
      [form]="form">
    </tidy-input>
  </form>
</div>
<tidy-button
  class="desktop-header-button"
  [image]="'assets/icon/filter-white.png'"
  [text]="'Filter'"
  [smallBody]="true"
  [matMenuTriggerFor]="menu"
  [matMenuTriggerData]="{closeDisabled: true}">
</tidy-button>
<tidy-button
  class="desktop-header-button primary-button"
  [image]="'assets/img/book-jobs-white.svg'"
  [text]="'Book Job(s)'"
  [smallBody]="true"
  [action]="boundBookJobSelectAddress">
</tidy-button>
<ion-spinner *ngIf="showLoadingSpinner" name="lines" class="header-loading-spinner"></ion-spinner>
</div>-->

@if (windowService.isDesktopRes) {
  <tidy-desktop-header [isLoading]="isLoading">
    <div class="wrappable-container chips-scrollable-wrap" [class.custom-date-range-active]="showCustomDateRange">
      <tidy-text
        [title]="'Schedule'" />
      @if (scheduleViewMode !== 'LIST') {
        <div class="vertical-align-center">
          <tidy-image
            (click)="goToPreviousPeriodAction()"
            [src]="'assets/icon/arrowhead.png'"
            class="body-size arrow-icon reverse-arrow" />
          <tidy-text
            [body]="getPeriodRangeText()" />
          <tidy-image
            (click)="goToNextPeriodAction()"
            [src]="'assets/icon/arrowhead.png'"
            class="body-size arrow-icon last-arrow" />
        </div>
      }
      @if (scheduleViewMode === 'LIST') {
        <div>
          @if (!showCustomDateRange) {
            <div style="width: 140px">
              <form [formGroup]="form">
                <tidy-header-select
                  [items]="dateRangeSelectOptions"
                  [form]="form.get('dateRangeOption')"
                  formControlName="dateRangeOption"
                  [disabled]="showAboutThisPage"
                  (optionChange)="changeDateRangeOption($event)"
                  [icon]="'assets/svg/calendar.svg'"
                  class="desktop-header-field" />
              </form>
            </div>
          }
          @if (showCustomDateRange) {
            <div>
              <div style="display: flex; gap: 8px; align-items: flex-start;">
                <a
                  href="javascript:void(0)"
                  (click)="goBackToDropdown()"
                  class="back-to-dropdown-link">
                  <span class="back-arrow">←</span>
                  {{ 'Other dates' | translate }}
                </a>
                <div style="width: 140px;">
                  <form [formGroup]="form">
                    <tidy-datepicker
                      [label]="'Start Date'"
                      [icon]="'assets/svg/calendar.svg'"
                      formControlName="startDate"
                      [form]="form.controls.startDate"
                      [submitted]="false"
                      [disabled]="showAboutThisPage"
                      (optionChange)="onStartDateChange($event)"
                      class="desktop-header-field" />
                  </form>
                </div>
                <span style="color: #666; font-size: 12px; padding-top: 8px;">{{ 'to' | translate }}</span>
                <div style="width: 140px;">
                  <form [formGroup]="form">
                    <tidy-datepicker
                      [label]="'End Date'"
                      [icon]="'assets/svg/calendar.svg'"
                      formControlName="endDate"
                      [form]="form.controls.endDate"
                      [submitted]="false"
                      [minDate]="form.controls.startDate.value"
                      [disabled]="showAboutThisPage"
                      (optionChange)="onEndDateChange($event)"
                      class="desktop-header-field" />
                  </form>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <div class="select-container">
        <form [formGroup]="form">
          <tidy-header-select
            [items]="scheduleViewModeList"
            [form]="form.get('scheduleViewMode')"
            formControlName="scheduleViewMode"
            [disabled]="showAboutThisPage"
            (optionChange)="changeScheduleViewModeAction($event)"
            [icon]="'assets/svg/list.svg'" />
        </form>
      </div>
      <form [formGroup]="form" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <tidy-small-button
        [text]="'Filter'"
        [image]="'assets/img/filter-white.svg'"
        [matMenuTriggerFor]="menu"
        [matMenuTriggerDisabled]="showAboutThisPage"
        [matMenuTriggerData]="{closeDisabled: true}" />
      <tidy-small-button
        [text]="'Add Job'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="bookJobSelectAddress()" />
      @if (isRentalClient) {
        <tidy-small-button
          [text]="'Block Dates'"
          [image]="'assets/svg/lock-closed-outline-white.svg'"
          (buttonClick)="addOwnerBlock.emit()" />
      }
      @for (chip of chips; track chip) {
        <ion-chip class="filter-chip">
          @if (chip.parentName === 'service' && chip.icon?.startsWith('assets/')) {
            <img [src]="chip.icon" class="chip-service-icon" />
          } @else if (chip.icon) {
            <mat-icon
              class="chip-icon"
              [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
          }
          <ion-label>{{ chip.name | titlecase }}</ion-label>
          <ion-icon name="close-circle" (click)="removeChip(chip)" />
        </ion-chip>
      }
    </div>
    <div class="non-wrappable-right-aligned-container">
      @if (showLoadingSpinner) {
        <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px;" />
      }
      <automations-preview-button
        [tag]="'schedule'" />
    </div>
  </tidy-desktop-header>
}

@if (!windowService.isDesktopRes) {
  <div>
    <div>
      <div class="vertical-align-center" style="margin-bottom: 15px; display: flex; justify-content: center;">
        <tidy-image
          (click)="goToPreviousPeriodAction()"
          [src]="'assets/icon/arrowhead.png'"
          class="body-size arrow-icon reverse-arrow" />
        <tidy-text
          [body]="(this.selectedPeriodRange.startDate | parseDateTime: 'MMM d') + ' - ' + (this.selectedPeriodRange.endDate | parseDateTime: 'MMM d')" />
        <tidy-image
          (click)="goToNextPeriodAction()"
          [src]="'assets/icon/arrowhead.png'"
          class="body-size arrow-icon last-arrow" />
      </div>
      <div style="margin-bottom: 10px; display: flex; align-items: center; width: 100%;">
        <div style="flex: 0 0 70%; padding-right: 10px">
          <form [formGroup]="form">
            <tidy-search-input
              formControlName="search"
              [placeholder]="'Search'"
              [icon]="'assets/svg/search.svg'"
              [fixedWidth]="false" 
              class="header-search" />
          </form>
        </div>
        <div style="flex: 0 0 30%;">
          <tidy-small-button
            [text]="'Filter'"
            [image]="'assets/img/filter-white.svg'"
            [matMenuTriggerFor]="menu"
            [matMenuTriggerDisabled]="showAboutThisPage"
            [matMenuTriggerData]="{closeDisabled: true}" />
        </div>
        <!--<div style="flex: 0 0 30%;">
        <tidy-button
          class="desktop-header-button"
          [image]="'assets/icon/filter-white.png'"
          [text]="'Filter'"
          [smallBody]="true"
          [matMenuTriggerFor]="menu"
          [matMenuTriggerData]="{closeDisabled: true}">
        </tidy-button>
      </div>-->
    </div>
  </div>
</div>
  @if (chips?.length > 0) {
    <div class="mobile-filter-chips">
      @for (chip of chips; track chip) {
        <ion-chip class="filter-chip">
          @if (chip.parentName === 'service' && chip.icon?.startsWith('assets/')) {
            <img [src]="chip.icon" class="chip-service-icon" />
          } @else if (chip.icon) {
            <mat-icon
              class="chip-icon"
              [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
          }
          <ion-label>{{ chip.name | titlecase }}</ion-label>
          <ion-icon name="close-circle" (click)="removeChip(chip)" />
        </ion-chip>
      }
    </div>
  }
}

<mat-menu #menu="matMenu" class="filter-menu">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-menu-item matTreeNodeToggle class="tree-node-padding">
        <mat-checkbox
          class="checkbox"
          [checked]="getNodeChecked(node)"
          (click)="$event.stopPropagation()"
          (change)="checkNode(node, $event)">
          {{ node.name | titlecase | translate }}
        </mat-checkbox>
      </button>
    </mat-tree-node>
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding>
      <button
        class="node-button-padding"
        mat-menu-item
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        {{ node.name | titlecase | translate }}
      </button>
    </mat-tree-node>
  </mat-tree>
</mat-menu>
